/* src/app/workshop/partials/parts-form/parts-form.component.scss */
/*# sourceMappingURL=parts-form.component.css.map */
